/**
 *
 * NotFoundPage
 *
 */

import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components/macro';
import { Link as RLink } from 'react-router-dom';

export default function NotFoundPage(): ReactElement {
  return (
    <>
      <Helmet>
        <title>NotFoundPage</title>
        <meta name="description" content="Description of NotFoundPage" />
      </Helmet>
      <Layout>
        <h1>Page Not Found</h1>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          Click
          <RLink
            to="/"
            style={{ textDecoration: 'underscore', margin: '0 0.3em' }}
          >
            <span>here</span>
          </RLink>
          to go back to our main page
        </div>
      </Layout>
    </>
  );
}

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  padding-bottom: 10em;
`;
